var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5c-1.216 0-2.406.189-3.539.555A11.504 11.504 0 0 0 .5 12c0 6.351 5.149 11.5 11.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.957 11.805 9.08 15.827V7.784z"
  }))));
};
export default SvgPlay;